<template>
  <div id="app">

    <div v-if="validated">
      <app-header></app-header>
      <sidebar></sidebar>
      <div class="main"> 
        <router-view v-if="isAdmin"></router-view>
        <router-view v-else-if="clientReady" name="client"></router-view>
      </div>
    </div>

    <agreement v-else-if="agreement"></agreement>
    <setpassword v-else-if="setpwd"></setpassword>
    <invoice v-else-if="invoice"></invoice>
    <receipt v-else-if="receipt"></receipt>
    <login v-else></login>

  </div>
</template>

<script>
import header from '@/components/header'
import sidebar from '@/components/sidebar'
import login from '@/components/users/login'
import setPassword from '@/components/users/setPassword'
import agreement from '@/components/agreements/agreement'
import invoice from '@/components/accounts/invoice'
import receipt from '@/components/accounts/receipt'

export default {
  name: 'app',
  components: {
    'app-header': header,
    'sidebar': sidebar,
    'login': login,
    'setpassword': setPassword,
    'agreement': agreement,
    'invoice': invoice,
    'receipt': receipt
  },
  computed: {
    validated: function () {
      return this.$root.$data.validated
    },
    isAdmin: function () {
      return this.$root.$data.admin
    },
    setpwd: function () {
      return window.location.href.includes('setpassword')
    },
    agreement: function () {
      return /agreements\/\w{24}/.test(window.location.href)
    },
    invoice: function () {
      return /invoices\/\w{24}/.test(window.location.href)
    },
    receipt: function () {
      return /receipts\/\w{24}/.test(window.location.href)
    },
    clientReady: function () {
      return this.$root.$data.client.ready
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,700');
html {
  overflow-y: scroll;
}
body {
  font-family: 'Open Sans', sans-serif !important;
  font-weight: 300!important;
  color: #222!important
}
h1, h2, h3, h4, h5, h6 {
  font-weight: 100!important
}
a.active, a:active, a:focus, a:hover {
  color: #136efb!important;
  text-decoration: underline;
}
.tab .tab-item a.active, .tab .tab-item.active a {
  border-bottom-color: #136efb!important;
  color: #136efb!important;
}
.form-checkbox input:checked+.form-icon, .form-radio input:checked+.form-icon, .form-switch input:checked+.form-icon {
  background: #136efb!important;
  border-color: #136efb!important;
}
.form-input:focus {
  border-color: #136efb!important;
}
.btn {
  font-weight: 300
}
.main {
  width: calc(100% - 242px - 2%);
  margin: 21px 0 0 243px;
}
.container {
  padding: 0!important;
  width: 100%
}
.form-input, .form-select {
  font-weight: 100
}
.form-input:focus {
  box-shadow: none!important;
}
.btn.btn-primary {
  background: #136efb!important;
  border-color: #136efb!important;
}
.btn.btn-primary:hover {
  background: #0358d8!important
}
.btn.btn-primary a {
  color:#fff
}
.btn.btn-primary a:hover {
  color: #fff!important;
  text-decoration: none;
}
a:focus {
  box-shadow: none!important
}
:focus {
  outline: none!important;
}
input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
}
.tooltipz {
  position: relative;
  background: #dceafe;
  color: #458efc;
  border-radius: 3px;
  font-size: 0.8em;
  padding: 1em;
}
.tooltipz:after {
  bottom: 100%;
  left: 6%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(34, 34, 34, 0);
  border-bottom-color: #dceafe;
  border-width: 8px;
  margin-left: -8px;
}
ul.docCreation {
  margin: 0;
}
ul.docCreation li {
  background-color: #3fa9f526;
  float: left;
  width: 22%;
  margin: 0 4% 41px 0;
  list-style: none;
  /* box-shadow: 3px 2px 10px #136efb; */
  border-radius: 2px;
  font-size: 1em;
  font-weight: 800;
  position: relative;
  height: 140px;
  border: 1px solid #136efb4d;
}
ul.docCreation li:after {
  content: "";
  width: 65%;
  height: 1px;
  background: #136efa;
  border-radius: 5px;
  position: absolute;
  bottom: 32px;
  left: 16px;
}
ul.docCreation li:hover {
  box-shadow: 3px 2px 10px #9590a0;
}
ul.docCreation li:nth-child(4n) {
  margin: 0 0 41px 0;
}
ul.docCreation li a {
  display: block;
  padding: 30px 10px 0 16px;
  color: #333;
  width: 100%;
  position: absolute;
  top: 0px;
  height: 138px;
}
ul.docCreation li a:hover {
  color: #333!important;
  text-decoration: none;
}
ul.docCreation li:hover:after {
  content: "";
  background: #ffa500;
}
/*a {
  color: #136efb
}*/
@media print {
   .main {
    width: 100%;
    margin: 0
   }
   body {
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif!important;
    color: #000;
    zoom:80%;
   }
}
@media (max-width: 599px) {
  ul.docCreation li {
    background-color: #fff;
    float: left;
    width: 48%;
    margin: 0 4% 41px 0;
  }
  ul.docCreation li:nth-child(2n) {
    margin: 0 0 41px 0;
  }
  ul.docCreation li:nth-child(4n) {
    margin: inherit;
  }
  ul.docCreation li a {
      padding: 41px 10px 0 16px;
  }
}
@page  
{ 
    size: auto;   /* auto is the initial value */ 
    /* this affects the margin in the printer settings */ 
    margin: 25mm 25mm 25mm 25mm;  
} 
</style>



// WEBPACK FOOTER //
// App.vue?d78db51a